var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAchtung(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    enableBackground: "new 0 0 48 48",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: 2.667,
    width: 48,
    height: 42.667
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#D51B0C",
    d: "M4.708,44.224c-1.765,0-3.364-0.875-4.177-2.286 c-0.714-1.245-0.708-2.672,0.016-3.917L19.844,4.926c0.823-1.416,2.375-2.26,4.156-2.26s3.333,0.844,4.156,2.26l19.297,33.094 c0.724,1.245,0.729,2.672,0.016,3.917c-0.813,1.411-2.411,2.286-4.177,2.286H4.708z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#FFFFFF",
    d: "M44.771,40.328c-0.307,0.531-0.958,0.859-1.708,0.859H4.938 c-0.75,0-1.402-0.328-1.708-0.859c-0.202-0.355-0.202-0.714,0.011-1.073L22.303,6.552c0.301-0.525,0.952-0.85,1.697-0.85 c0.745,0,1.391,0.324,1.698,0.85l19.063,32.703C44.974,39.614,44.974,39.973,44.771,40.328"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#1F1E21",
    d: "M25.886,12.271c-0.5-0.511-1.172-0.792-1.886-0.792s-1.385,0.281-1.891,0.792 c-0.5,0.51-0.766,1.188-0.754,1.906l0.317,16.667C21.693,32.104,22.74,33.13,24,33.13c1.261,0,2.308-1.025,2.328-2.286 l0.317-16.667C26.656,13.458,26.391,12.781,25.886,12.271"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#1F1E21",
    d: "M24,34.442c-1.254,0-2.276,1.021-2.276,2.276C21.724,37.979,22.746,39,24,39 c1.255,0,2.276-1.021,2.276-2.281C26.276,35.464,25.255,34.442,24,34.442"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAchtung);
export default __webpack_public_path__ + "static/media/Achtung.aa9f636b4fc19fb4d6b2db32a9a54f3e.svg";
export { ForwardRef as ReactComponent };